// Shared supplier list — used by the Partners page, industry pages and the presentation.
import spxflowLogo from '@/assets/partners/spxflow-alt.png';
import galdiLogo from '@/assets/partners/galdi-correct.png';
import elopakLogo from '@/assets/partners/elopak-red.jpg';
import cftGroupLogo from '@/assets/partners/cft-group.png';
import robotehLogo from '@/assets/partners/roboteh.png';
import plevnikLogo from '@/assets/partners/plevnik.png';
import tecnalLogo from '@/assets/partners/tecnal.png';
import gramEquipmentLogo from '@/assets/partners/gram-equipment.png';
import seitalLogo from '@/assets/partners/seital.png';
import trepkoLogo from '@/assets/partners/trepko.png';
import cartobolLogo from '@/assets/partners/cartobol.jpg';
import fossLogo from '@/assets/partners/foss.png';
import comacLogo from '@/assets/partners/comac.jpg';
import buhmannLogo from '@/assets/partners/buhmann.png';
import pattynLogo from '@/assets/partners/pattyn.png';
import seracLogo from '@/assets/partners/serac.png';

import mecathermLogo from '@/assets/partners/mecatherm.png';
import vmiLogo from '@/assets/partners/vmi.png';
import shickEsteveLogo from '@/assets/partners/shick-esteve.png';
import bfrSystemsLogo from '@/assets/partners/bfr-systems.png';
import enoopFoodLogo from '@/assets/partners/enoop-food.png';
import tecnovacLogo from '@/assets/partners/tecnovac.png';
import lomaxLogo from '@/assets/partners/lomax.png';
import gampackLogo from '@/assets/partners/gampack.png';
import fromfroidLogo from '@/assets/partners/fromfroid.png';
import coperionLogo from '@/assets/partners/coperion.png';
import bakerPerkinsLogo from '@/assets/partners/baker-perkins.jpg';
import diosnaLogo from '@/assets/partners/diosna.jpg';
import peerlessLogo from '@/assets/partners/peerless.jpg';
import shafferLogo from '@/assets/partners/shaffer.jpg';
import gerstenbergSchroderLogo from '@/assets/partners/gerstenberg-schroder.png';
import acmiLogoAsset from '@/assets/partners/acmi-logo.png.asset.json';
import anritsuLogo from '@/assets/partners/anritsu.png';
import cimeCaredduLogo from '@/assets/partners/cime-careddu.png';
import polpakLogo from '@/assets/partners/polpak.png';
import stmPackLogo from '@/assets/partners/stm-pack.png';
import vezzadiniLogo from '@/assets/partners/vezzadini.png';

export type Partner = {
  name: string;
  logo: string;
  founded?: string;
  hq?: { el: string; en: string };
  description: { el: string; en: string };
  strengths?: { el: string; en: string };
  category: { el: string; en: string };
  categoryIcons: string[];
  website?: string;
  brochures?: { label: { el: string; en: string }; url: string }[];
};

export const partnersData: Partner[] = [
  {
    name: 'SPX FLOW',
    logo: spxflowLogo,
    founded: '1912',
    hq: { el: 'Σάρλοτ, ΗΠΑ', en: 'Charlotte, USA' },
    description: { 
      el: 'Λύσεις επεξεργασίας τροφίμων & ποτών — ανάμειξη, διαχωρισμός, θερμική επεξεργασία.', 
      en: 'Food & beverage process solutions — mixing, separation, heat treatment.' 
    },
    strengths: { 
      el: 'Παγκόσμια παρουσία με κέντρα R&D και service σε 35+ χώρες.', 
      en: 'Global presence with R&D and service centers in 35+ countries.' 
    },
    category: { el: 'Επεξεργασία', en: 'Processing' },
    categoryIcons: ['dairy', 'beverage', 'bakery', 'meat', 'oils', 'spreads', 'fruit', 'ready-meals'],
    website: 'https://www.spxflow.com',
    brochures: [
      {
        label: { el: 'Αντλίες & Βαλβίδες APV', en: 'Pumps & Valves APV' },
        url: '/brochures/spx-flow-pumps-valves-apv.pdf',
      },
      {
        label: { el: 'Εναλλάκτες Θερμότητας – Τεχνικός Πίνακας', en: 'Heat Exchangers – Technical Table' },
        url: '/brochures/spx-flow-heat-exchangers-technical-table.pdf',
      },
    ],
  },
  {
    name: 'Seital (SPX FLOW)',
    logo: seitalLogo,
    founded: '1983',
    hq: { el: 'Πάρμα, Ιταλία', en: 'Parma, Italy' },
    description: { 
      el: 'Εξοπλισμός διαχωρισμού και καθαρισμού για γαλακτοκομία, ποτά, οινοποιία και ζυθοποιία.', 
      en: 'Separation and clarification equipment for dairy, beverage, wine, and brewing.' 
    },
    strengths: { 
      el: 'Συνδυάζει την ιταλική ακριβή μηχανολογία με την παγκόσμια εμπειρία και το δίκτυο service της SPX FLOW.', 
      en: 'Combines Italian precision engineering with SPX FLOW\'s global expertise and service network.' 
    },
    category: { el: 'Επεξεργασία', en: 'Processing' },
    categoryIcons: ['dairy', 'beverage', 'oils'],
    website: 'https://www.spxflow.com/seital-separation',
    brochures: [
      {
        label: { el: 'Διαχωριστήρες & Ομογενοποιητές', en: 'Separators & Homogenisers' },
        url: '/brochures/seital-separators-homogenisers.pdf',
      },
    ],
  },
  {
    name: 'Gerstenberg Schröder (SPX FLOW)',
    logo: gerstenbergSchroderLogo,
    founded: '1901',
    hq: { el: 'Κοπεγχάγη, Δανία', en: 'Copenhagen, Denmark' },
    description: { 
      el: 'Εξοπλισμός κρυστάλλωσης και επεξεργασίας λιπών & ελαίων για μαργαρίνη, αλείμματα και βούτυρο.', 
      en: 'Crystallization and fats & oils processing equipment for margarine, spreads, and butter.' 
    },
    strengths: { 
      el: 'Πάνω από 120 χρόνια εμπειρίας στην επεξεργασία λιπών, με καινοτόμες τεχνολογίες κρυστάλλωσης και παγκόσμιο δίκτυο υποστήριξης.', 
      en: 'Over 120 years of experience in fats processing, with innovative crystallization technologies and a global support network.' 
    },
    category: { el: 'Επεξεργασία', en: 'Processing' },
    categoryIcons: ['oils', 'spreads', 'dairy'],
    website: 'https://www.spxflow.com/gerstenberg-schroder'
  },
  {
    name: 'Plevnik',
    logo: plevnikLogo,
    founded: '1992',
    hq: { el: 'Σλοβενία', en: 'Slovenia' },
    description: { 
      el: 'Γαλακτοκομικός εξοπλισμός για μικρές και μεσαίες μονάδες — παστεριωτές, τυροκομικοί λέβητες, πρέσες, ψύξη.', 
      en: 'Dairy equipment for small and medium plants — pasteurizers, cheese kettles, presses, cooling.' 
    },
    strengths: { 
      el: 'Ισχυρή R&D και εσωτερική παραγωγή, προσφέροντας ευελιξία και υψηλή ποιότητα για εξειδικευμένες αγορές γαλακτοκομικών.', 
      en: 'Strong R&D and in-house manufacturing, offering flexibility and high quality for niche dairy markets.' 
    },
    category: { el: 'Γαλακτοκομικά', en: 'Dairy' },
    categoryIcons: ['dairy', 'beverage', 'spreads'],
    website: 'https://www.plevnik.eu'
  },
  {
    name: 'Tecnal',
    logo: tecnalLogo,
    founded: '1960s',
    hq: { el: 'Νιόρ, Γαλλία', en: 'Niort, France' },
    description: { 
      el: 'Εξοπλισμός τυροκομίας και γαλακτοκομίας — διαμόρφωση, στράγγιση, αλάτισμα, ωρίμανση.', 
      en: 'Cheesemaking and dairy equipment — moulding, draining, salting, ripening.' 
    },
    strengths: { 
      el: 'Πάνω από 50 χρόνια εμπειρίας, με γραφεία σχεδιασμού σε υδραυλικά, μηχανικά και αυτοματισμό, προσφέροντας ολοκληρωμένες turnkey μονάδες.', 
      en: 'Over 50 years of expertise, with design offices in hydraulics, mechanics, and automation, offering complete turnkey plants.' 
    },
    category: { el: 'Γαλακτοκομικά', en: 'Dairy' },
    categoryIcons: ['dairy', 'spreads'],
    website: 'https://www.tecnal.fr'
  },
  {
    name: 'Gram Equipment',
    logo: gramEquipmentLogo,
    founded: '1901',
    hq: { el: 'Δανία', en: 'Denmark' },
    description: { 
      el: 'Γραμμές βιομηχανικής παραγωγής παγωτού — καταψύκτες, εξώθηση, διαμόρφωση, συσκευασία.', 
      en: 'Industrial ice cream production lines — freezers, extrusion, moulding, wrapping.' 
    },
    strengths: { 
      el: 'Παγκόσμιος ηγέτης με πάνω από έναν αιώνα εμπειρίας, ~600 εργαζόμενους και υποστήριξη service παγκοσμίως.', 
      en: 'Global leader with more than a century of experience, ~600 employees, and service support worldwide.' 
    },
    category: { el: 'Παγωτό', en: 'Ice Cream' },
    categoryIcons: ['dairy'],
    website: 'https://www.gram-equipment.com'
  },
  {
    name: 'Galdi',
    logo: galdiLogo,
    founded: '1985',
    hq: { el: 'Τρεβίζο, Ιταλία', en: 'Treviso, Italy' },
    description: { 
      el: 'Αυτόματες μηχανές πλήρωσης χαρτοκιβωτίων gable-top για γάλα, χυμούς και φυτικά ροφήματα.', 
      en: 'Automatic gable-top carton filling machines for milk, juice, and plant-based drinks.' 
    },
    strengths: { 
      el: 'Ηγέτης στην πλήρωση χαρτοκιβωτίων με υγιεινό σχεδιασμό και υπηρεσίες αυτοματισμού. Ισχυρή παγκόσμια παρουσία.', 
      en: 'Leader in carton filling with hygienic design and automation services. Strong global presence.' 
    },
    category: { el: 'Συσκευασία', en: 'Packaging' },
    categoryIcons: ['dairy', 'beverage', 'meat'],
    website: 'https://www.galdi.it'
  },
  {
    name: 'Elopak',
    logo: elopakLogo,
    founded: '1957',
    hq: { el: 'Όσλο, Νορβηγία', en: 'Oslo, Norway' },
    description: { 
      el: 'Βιώσιμα συστήματα συσκευασίας χαρτοκιβωτίων Pure-Pak® για ποτά.', 
      en: 'Sustainable Pure-Pak® carton packaging systems for beverages.' 
    },
    strengths: { 
      el: 'Πρωτοπόρος σε ανανεώσιμη και ανακυκλώσιμη συσκευασία χαρτοκιβωτίων, ουδέτερη σε άνθρακα, ασηπτικές γραμμές πλήρωσης.', 
      en: 'Pioneer in renewable and recyclable carton packaging, carbon-neutral board, aseptic filling lines.' 
    },
    category: { el: 'Συσκευασία', en: 'Packaging' },
    categoryIcons: ['dairy', 'beverage', 'meat'],
    website: 'https://www.elopak.com',
    brochures: [
      {
        label: { el: 'Χαρτοκυτία', en: 'Cartons' },
        url: '/brochures/elopak-xartokitia.pdf',
      },
      {
        label: { el: 'Καπάκια', en: 'Caps' },
        url: '/brochures/elopak-kapakia.pdf',
      },
    ],
  },
  {
    name: 'Trepko',
    logo: trepkoLogo,
    founded: '1945',
    hq: { el: 'Δανία', en: 'Denmark' },
    description: { 
      el: 'Μηχανές πλήρωσης και συσκευασίας για γαλακτοκομικά και τρόφιμα.', 
      en: 'Filling and packaging machines for dairy and food industries.' 
    },
    strengths: { 
      el: 'Αξιόπιστος ευρωπαϊκός κατασκευαστής με ισχυρές αγορές εξαγωγών. Modularity γραμμές με προηγμένο αυτοματισμό.', 
      en: 'Trusted European manufacturer with strong export markets. Modular filling lines with advanced automation.' 
    },
    category: { el: 'Συσκευασία', en: 'Packaging' },
    categoryIcons: ['dairy', 'beverage', 'oils', 'spreads'],
    website: 'https://www.trepko.com'
  },
  {
    name: 'Buhmann',
    logo: buhmannLogo,
    founded: '1980',
    hq: { el: 'Γερμανία', en: 'Germany' },
    description: { 
      el: 'Μηχανές χαρτονοποίησης και συσκευασίας για τρόφιμα και μη τρόφιμα.', 
      en: 'Cartoning and packaging machines for food and non-food products.' 
    },
    strengths: { 
      el: 'Φημισμένη για την ακριβή γερμανική μηχανολογία και ανθεκτικές λύσεις.', 
      en: 'Renowned for precision German engineering and robust solutions.' 
    },
    category: { el: 'Συσκευασία', en: 'Packaging' },
    categoryIcons: ['dairy', 'beverage', 'bakery', 'meat', 'oils', 'spreads', 'fruit', 'ready-meals'],
    website: 'https://www.buhmann.com'
  },
  {
    name: 'Gampack',
    logo: gampackLogo,
    founded: '2003',
    hq: { el: 'Ιταλία', en: 'Italy' },
    description: { 
      el: 'Μηχανές δευτερογενούς συσκευασίας (wrap-around, shrink-wrapping, case packers).', 
      en: 'Secondary packaging machinery (wrap-around, shrink-wrapping, case packers).' 
    },
    strengths: { 
      el: 'Ταχέως αναπτυσσόμενη ιταλική εταιρεία με καινοτόμο προσέγγιση.', 
      en: 'Rapidly growing Italian company with innovative approach.' 
    },
    category: { el: 'Συσκευασία', en: 'Packaging' },
    categoryIcons: ['dairy', 'beverage', 'bakery', 'meat', 'oils', 'spreads', 'fruit', 'ready-meals'],
    website: 'https://www.gampack.com'
  },
  {
    name: 'Roboteh',
    logo: robotehLogo,
    founded: '2006',
    hq: { el: 'Σλοβενία', en: 'Slovenia' },
    description: { 
      el: 'Ρομποτικός αυτοματισμός και λύσεις συσκευασίας τέλους γραμμής.', 
      en: 'Robotic automation and end-of-line packaging solutions.' 
    },
    strengths: { 
      el: 'Μηχανολογική εταιρεία επικεντρωμένη στην ευελιξία και τον εξατομικευμένο αυτοματισμό.', 
      en: 'Engineering company focused on flexibility and tailored automation.' 
    },
    category: { el: 'Αυτοματισμός', en: 'Automation' },
    categoryIcons: ['dairy', 'beverage', 'bakery', 'meat', 'oils', 'spreads', 'fruit', 'ready-meals'],
    website: 'https://www.roboteh.si'
  },
  {
    name: 'Cartobol',
    logo: cartobolLogo,
    founded: '1970s',
    hq: { el: 'Ιταλία', en: 'Italy' },
    description: { 
      el: 'Μηχανές καπακώματος και wire-hooding για οίνο, αλκοολούχα ποτά και ροφήματα.', 
      en: 'Capping and wire-hooding machines for wine, spirits, and beverages.' 
    },
    strengths: { 
      el: 'Ηγέτης σε μηχανές wire-hooding για αφρώδεις οίνους. Αξιόπιστος συνεργάτης για τη βιομηχανία ποτών στην Ευρώπη.', 
      en: 'Leader in sparkling wine wire-hooding machines. Trusted partner for the beverage industry in Europe.' 
    },
    category: { el: 'Ποτά', en: 'Beverages' },
    categoryIcons: ['dairy', 'beverage', 'meat', 'oils', 'spreads'],
    website: 'https://cartobol.es/en/'
  },
  {
    name: 'Pattyn',
    logo: pattynLogo,
    founded: '1952',
    hq: { el: 'Βέλγιο', en: 'Belgium' },
    description: { 
      el: 'Γραμμές συσκευασίας για αρτοσκευάσματα, σοκολάτα και συστατικά τροφίμων.', 
      en: 'Packaging lines for bakery, chocolate, and food ingredients.' 
    },
    strengths: { 
      el: 'Οικογενειακός όμιλος με παγκόσμιο δίκτυο και κουλτούρα καινοτομίας.', 
      en: 'Family-owned group with global network and innovation-driven culture.' 
    },
    category: { el: 'Συσκευασία', en: 'Packaging' },
    categoryIcons: ['bakery', 'meat', 'oils', 'spreads', 'fruit'],
    website: 'https://www.pattyn.com'
  },
  {
    name: 'Serac',
    logo: seracLogo,
    founded: '1969',
    hq: { el: 'Λα Φερτέ-Μπερνάρ, Γαλλία', en: 'La Ferté-Bernard, France' },
    description: { 
      el: 'Λύσεις πλήρωσης υγρών, καπακώματος και blow-moulding.', 
      en: 'Liquid filling, capping, and blow-moulding solutions.' 
    },
    strengths: { 
      el: 'Πάνω από 50 χρόνια εμπειρίας με ισχυρή παγκόσμια παρουσία. Τεχνολογία BluStream® e-beam sterilization.', 
      en: 'Over 50 years of expertise with a strong global presence. BluStream® e-beam sterilization technology.' 
    },
    category: { el: 'Συσκευασία', en: 'Packaging' },
    categoryIcons: ['dairy', 'beverage'],
    website: 'https://www.serac-group.com'
  },
  {
    name: 'FOSS',
    logo: fossLogo,
    founded: '1956',
    hq: { el: 'Χίλερεντ, Δανία', en: 'Hillerød, Denmark' },
    description: { 
      el: 'Αναλυτικά όργανα για τρόφιμα, γεωργία και γαλακτοκομία.', 
      en: 'Analytical instruments for food, agriculture, and dairy industries.' 
    },
    strengths: { 
      el: 'Πρωτοπόροι στην υπέρυθρη φασματοσκοπία για έλεγχο ποιότητας τροφίμων. Πάνω από 100 διπλώματα ευρεσιτεχνίας.', 
      en: 'Pioneers in infrared spectroscopy for food quality testing. Over 100 patents.' 
    },
    category: { el: 'Εργαστηριακός Εξοπλισμός', en: 'Laboratory Equipment' },
    categoryIcons: ['dairy', 'beverage', 'bakery', 'meat', 'oils', 'spreads', 'fruit', 'ready-meals'],
    website: 'https://www.fossanalytics.com',
    brochures: [
      {
        label: { el: 'Ποιοτικός Έλεγχος', en: 'Quality Control' },
        url: '/brochures/foss-quality-control.pdf',
      },
    ],
  },
  {
    name: 'Comac',
    logo: comacLogo,
    founded: '1990',
    hq: { el: 'Ιταλία', en: 'Italy' },
    description: { 
      el: 'Συστήματα πλήρωσης και συσκευασίας για μπίρα, αναψυκτικά και ποτά.', 
      en: 'Filling and packaging systems for beer, soft drinks, and beverages.' 
    },
    strengths: { 
      el: 'Ισχυρή φήμη για ευέλικτα συστήματα συσκευασίας ποτών. Ολοκληρωμένες γραμμές kegging, bottling και canning.', 
      en: 'Strong reputation for flexible beverage packaging systems. Complete kegging, bottling and canning lines.' 
    },
    category: { el: 'Ποτά', en: 'Beverages' },
    categoryIcons: ['beverage'],
    website: 'https://www.comacitalia.it'
  },
  {
    name: 'CFT Group',
    logo: cftGroupLogo,
    founded: '1945',
    hq: { el: 'Πάρμα, Ιταλία', en: 'Parma, Italy' },
    description: { 
      el: 'Λύσεις επεξεργασίας και συσκευασίας για τρόφιμα και ποτά.', 
      en: 'Processing and packaging solutions for food and beverages.' 
    },
    strengths: { 
      el: 'Καθιερωμένος όμιλος με ολοκληρωμένη εμπειρία επεξεργασίας. Turnkey γραμμές τομάτας, φρούτων και ποτών.', 
      en: 'Well-established group with comprehensive processing expertise. Turnkey tomato, fruit, and beverage processing lines.' 
    },
    category: { el: 'Επεξεργασία', en: 'Processing' },
    categoryIcons: ['dairy', 'beverage', 'meat', 'oils', 'spreads', 'fruit'],
    website: 'https://www.cft-group.com'
  },
  {
    name: 'Mecatherm',
    logo: mecathermLogo,
    founded: '1964',
    hq: { el: 'Μπαρεμπάχ, Γαλλία', en: 'Barembach, France' },
    description: { 
      el: 'Βιομηχανικός εξοπλισμός αρτοποιίας (φούρνοι, θάλαμοι ωρίμανσης, ψυκτικά).', 
      en: 'Industrial bakery equipment (ovens, proofers, coolers).' 
    },
    strengths: { 
      el: 'Ηγέτης στη βιομηχανική τεχνολογία αρτοποιίας με παγκόσμια εμβέλεια.', 
      en: 'Leader in industrial baking technology with global reach.' 
    },
    category: { el: 'Αρτοποιία', en: 'Bakery' },
    categoryIcons: ['bakery'],
    website: 'https://www.mecatherm.fr'
  },
  {
    name: 'VMI',
    logo: vmiLogo,
    founded: '1945',
    hq: { el: 'Γαλλία', en: 'France' },
    description: { 
      el: 'Εξοπλισμός ανάμειξης για αρτοποιία, καλλυντικά, χημικά και τρόφιμα.', 
      en: 'Mixing equipment for bakery, cosmetics, chemicals, and food.' 
    },
    strengths: { 
      el: 'Δεκαετίες καινοτομίας σε λύσεις ανάμειξης παγκοσμίως.', 
      en: 'Decades of innovation in mixing solutions worldwide.' 
    },
    category: { el: 'Αρτοποιία', en: 'Bakery' },
    categoryIcons: ['bakery'],
    website: 'https://www.vmimixing.com'
  },
  {
    name: 'Shick Esteve',
    logo: shickEsteveLogo,
    founded: '1956',
    hq: { el: 'ΗΠΑ / Γαλλία', en: 'USA / France' },
    description: { 
      el: 'Συστήματα αυτοματισμού συστατικών (αποθήκευση, χειρισμός, δοσομέτρηση).', 
      en: 'Ingredient automation systems (storage, handling, dosing).' 
    },
    strengths: { 
      el: 'Ισχυρή εμπειρία στη διαχείριση συστατικών για βιομηχανίες τροφίμων.', 
      en: 'Strong expertise in ingredient management for food industries.' 
    },
    category: { el: 'Αρτοποιία', en: 'Bakery' },
    categoryIcons: ['bakery'],
    website: 'https://www.shickesteve.com'
  },
  {
    name: 'BFR Systems',
    logo: bfrSystemsLogo,
    founded: '1980',
    hq: { el: 'Γαλλία', en: 'France' },
    description: { 
      el: 'Υγιεινές λύσεις μεταφοράς και συσκευασίας για κρέας, γαλακτοκομικά, αρτοποιία.', 
      en: 'Hygienic conveying and packaging for meat, dairy, and bakery.' 
    },
    strengths: { 
      el: 'Αξιόπιστος συνεργάτης για υγιεινά και ασφαλή περιβάλλοντα παραγωγής.', 
      en: 'Reliable partner for hygienic and safe production environments.' 
    },
    category: { el: 'Συσκευασία', en: 'Packaging' },
    categoryIcons: ['dairy', 'bakery', 'ready-meals'],
    website: 'https://www.bfrsystems.com/en/'
  },
  {
    name: 'Enoop',
    logo: enoopFoodLogo,
    founded: '2006',
    hq: { el: 'Σλοβενία', en: 'Slovenia' },
    description: { 
      el: 'Ενεργειακές λύσεις, αντλίες θερμότητας και συστήματα ανανεώσιμης ενέργειας.', 
      en: 'Energy solutions, heat pumps, and renewable energy systems.' 
    },
    strengths: { 
      el: 'Ολοκληρωμένες λύσεις ανανεώσιμης ενέργειας και βιομηχανικής θέρμανσης/ψύξης.', 
      en: 'Integrated renewable energy and industrial heating/cooling solutions.' 
    },
    category: { el: 'Ενέργεια', en: 'Energy' },
    categoryIcons: ['spreads'],
    website: 'https://www.enoopfood.tech/'
  },
  {
    name: 'Lomax',
    logo: lomaxLogo,
    founded: '1990',
    hq: { el: 'Ιταλία', en: 'Italy' },
    description: { 
      el: 'Μηχανές δευτερογενούς συσκευασίας (case packers, shrink wrapping).', 
      en: 'Secondary packaging machinery (case packers, shrink wrapping).' 
    },
    strengths: { 
      el: 'Ιταλική τεχνογνωσία με έμφαση στην αξιοπιστία και προσαρμοστικότητα.', 
      en: 'Italian know-how with emphasis on reliability and adaptability.' 
    },
    category: { el: 'Συσκευασία', en: 'Packaging' },
    categoryIcons: ['dairy', 'bakery', 'meat', 'ready-meals'],
    website: 'https://www.lomaxtech.com/'
  },
  {
    name: 'Tecnovac',
    logo: tecnovacLogo,
    founded: '1964',
    hq: { el: 'Ιταλία', en: 'Italy' },
    description: { 
      el: 'Μηχανές συσκευασίας κενού αέρος και θερμοδιαμόρφωσης.', 
      en: 'Vacuum packaging and thermoforming machines.' 
    },
    strengths: { 
      el: 'Πάνω από μισό αιώνα καινοτομίας σε μηχανές συσκευασίας τροφίμων. Προηγμένες λύσεις MAP.', 
      en: 'Over half a century of innovation in food packaging machinery. Advanced MAP solutions.' 
    },
    category: { el: 'Συσκευασία', en: 'Packaging' },
    categoryIcons: ['dairy', 'bakery'],
    website: 'https://www.tecnovac.com'
  },
  {
    name: 'Fromfroid',
    logo: fromfroidLogo,
    founded: '1986',
    hq: { el: 'Αβινιόν, Γαλλία', en: 'Avignon, France' },
    description: { 
      el: 'Εξοπλισμός ψύξης και ωρίμανσης για γαλακτοκομία — τούνελ ταχείας ψύξης για γιαούρτι.', 
      en: 'Cooling and maturation equipment for dairy — rapid cooling tunnels for yoghurt.' 
    },
    strengths: { 
      el: 'Πρωτοπόροι σε τεχνολογίες υπερταχείας ψύξης που μειώνουν τον χρόνο επεξεργασίας έως 75%, εξασφαλίζοντας ασφάλεια προϊόντος, σταθερή υφή και εξοικονόμηση ενέργειας.', 
      en: 'Pioneers in ultra-fast cooling technologies that reduce processing time by up to 75%, ensuring product safety, consistent texture, and energy savings.' 
    },
    category: { el: 'Γαλακτοκομικά', en: 'Dairy' },
    categoryIcons: ['dairy', 'ready-meals'],
    website: 'https://www.fromfroid.com'
  },
  {
    name: 'Coperion',
    logo: coperionLogo,
    founded: '1879',
    hq: { el: 'Στουτγκάρδη, Γερμανία', en: 'Stuttgart, Germany' },
    description: { 
      el: 'Συστήματα μεταφοράς, δοσομέτρησης, ζύγισης και ανάμειξης υλικών χύδην.', 
      en: 'Bulk material handling, feeding, weighing, and mixing systems.' 
    },
    strengths: { 
      el: 'Τεχνολογίες αιχμής σε πνευματική μεταφορά, εξώθηση και compounding, με πάνω από 140 χρόνια εμπειρίας και παρουσία σε 50+ χώρες.', 
      en: 'Cutting-edge technologies in pneumatic conveying, extrusion and compounding, with over 140 years of experience and presence in 50+ countries.' 
    },
    category: { el: 'Επεξεργασία', en: 'Processing' },
    categoryIcons: ['bakery'],
    website: 'https://www.coperion.com'
  },
  {
    name: 'Baker Perkins',
    logo: bakerPerkinsLogo,
    founded: '1903',
    hq: { el: 'Πίτερμπορο, Αγγλία', en: 'Peterborough, UK' },
    description: { 
      el: 'Γραμμές παραγωγής μπισκότων, κράκερ, σνακ, γλυκών και δημητριακών. Μέλος Coperion.', 
      en: 'Production lines for biscuits, crackers, snacks, confectionery, and cereals. A Coperion brand.' 
    },
    strengths: { 
      el: 'Πάνω από 120 χρόνια εμπειρίας στη βιομηχανική αρτοποιία και ζαχαρωτά, με παγκόσμια εγκατεστημένη βάση.', 
      en: 'Over 120 years of experience in industrial bakery and confectionery, with a global installed base.' 
    },
    category: { el: 'Αρτοποιία', en: 'Bakery' },
    categoryIcons: ['bakery'],
    website: 'https://www.bakerperkins.com'
  },
  {
    name: 'Diosna',
    logo: diosnaLogo,
    founded: '1885',
    hq: { el: 'Όσναμπρυκ, Γερμανία', en: 'Osnabrück, Germany' },
    description: { 
      el: 'Βιομηχανικά μηχανήματα ζύμωσης και ανάμειξης για αρτοποιία. Μέλος Coperion.', 
      en: 'Industrial dough mixing and kneading machines for bakery. A Coperion brand.' 
    },
    strengths: { 
      el: 'Πάνω από 135 χρόνια τεχνογνωσίας στη ζύμωση, με προηγμένα συστήματα ελέγχου και υγιεινού σχεδιασμού.', 
      en: 'Over 135 years of dough expertise, with advanced control systems and hygienic design.' 
    },
    category: { el: 'Αρτοποιία', en: 'Bakery' },
    categoryIcons: ['bakery'],
    website: 'https://www.diosna.com'
  },
  {
    name: 'Peerless',
    logo: peerlessLogo,
    founded: '1935',
    hq: { el: 'Σίδνεϊ, Οχάιο, ΗΠΑ', en: 'Sidney, Ohio, USA' },
    description: { 
      el: 'Βιομηχανικοί αναμείκτες και συστήματα ζύμης μεγάλης κλίμακας. Μέλος Coperion.', 
      en: 'Industrial mixers and large-scale dough handling systems. A Coperion brand.' 
    },
    strengths: { 
      el: 'Κορυφαίος κατασκευαστής αναμεικτών ζύμης στη Βόρεια Αμερική, με δεκαετίες αξιοπιστίας στη βιομηχανική αρτοποιία.', 
      en: 'Leading dough mixer manufacturer in North America, with decades of reliability in industrial bakery.' 
    },
    category: { el: 'Αρτοποιία', en: 'Bakery' },
    categoryIcons: ['bakery'],
    website: 'https://www.peerlessfood.com'
  },
  {
    name: 'Shaffer',
    logo: shafferLogo,
    founded: '1956',
    hq: { el: 'Ούρμπανα, Οχάιο, ΗΠΑ', en: 'Urbana, Ohio, USA' },
    description: { 
      el: 'Συστήματα χειρισμού ζύμης — κοπή, στρογγυλοποίηση, ενδιάμεση στάθμευση. Μέλος Coperion.', 
      en: 'Dough handling — dividing, rounding, and intermediate proofing. A Coperion brand.' 
    },
    strengths: { 
      el: 'Εξειδίκευση σε πλήρεις γραμμές make-up ζύμης, με έμφαση στην αξιοπιστία και ελάχιστη συντήρηση.', 
      en: 'Specialization in complete dough make-up lines, with emphasis on reliability and minimal maintenance.' 
    },
    category: { el: 'Αρτοποιία', en: 'Bakery' },
    categoryIcons: ['bakery'],
    website: 'https://www.shaffermixers.com'
  },
  {
    name: 'ACMI',
    logo: acmiLogoAsset.url,
    founded: '1985',
    hq: { el: 'Φιορενζουόλα ντ\'Άρντα, Ιταλία', en: 'Fiorenzuola d\'Arda, Italy' },
    description: {
      el: 'Ετικετέζες και ολοκληρωμένα συστήματα ετικετοποίησης για όλους τους κλάδους τροφίμων & ποτών.',
      en: 'Labellers and complete labelling systems for all food & beverage segments.'
    },
    strengths: {
      el: 'Υψηλή ταχύτητα, ευελιξία και αξιοπιστία σε πλήρεις γραμμές συσκευασίας.',
      en: 'High-speed, flexible and reliable solutions across complete packaging lines.'
    },
    category: { el: 'Ετικετοποίηση', en: 'Labelling' },
    categoryIcons: ['dairy', 'beverage', 'bakery', 'meat', 'oils', 'spreads', 'fruit', 'ready-meals'],
    website: 'https://www.acmispa.it'
  },
  {
    name: 'Anritsu',
    logo: anritsuLogo,
    founded: '1895',
    hq: { el: 'Τόκιο, Ιαπωνία', en: 'Tokyo, Japan' },
    description: {
      el: 'Συστήματα ελέγχου ποιότητας — ακτίνες Χ, ανιχνευτές μετάλλων, ελεγκτές βάρους για όλους τους κλάδους.',
      en: 'Quality inspection systems — X-ray, metal detectors and checkweighers for all segments.'
    },
    strengths: {
      el: 'Παγκόσμιος ηγέτης στον έλεγχο ποιότητας με υψηλή ακρίβεια και αξιοπιστία.',
      en: 'Global leader in quality inspection with high accuracy and reliability.'
    },
    category: { el: 'Έλεγχος Ποιότητας', en: 'Quality Control' },
    categoryIcons: ['dairy', 'beverage', 'bakery', 'meat', 'oils', 'spreads', 'fruit', 'ready-meals'],
    website: 'https://www.anritsu.com'
  },
  {
    name: 'Cime Careddu',
    logo: cimeCaredduLogo,
    founded: '1962',
    hq: { el: 'Ιταλία', en: 'Italy' },
    description: {
      el: 'Μηχανές πλήρωσης για τον κλάδο των ποτών.',
      en: 'Filling machines for the beverage segment.'
    },
    strengths: {
      el: 'Εξειδίκευση σε αξιόπιστες και ευέλικτες λύσεις πλήρωσης.',
      en: 'Specialization in reliable and flexible filling solutions.'
    },
    category: { el: 'Ποτά', en: 'Beverages' },
    categoryIcons: ['beverage'],
    website: 'https://www.cimecareddu.com'
  },
  {
    name: 'Polpak',
    logo: polpakLogo,
    founded: '2001',
    hq: { el: 'Πολωνία', en: 'Poland' },
    description: {
      el: 'Doy pack συσκευασίες για όλους τους κλάδους τροφίμων & ποτών.',
      en: 'Doy pack packaging solutions for all food & beverage segments.'
    },
    strengths: {
      el: 'Ευέλικτες λύσεις συσκευασίας σε σακούλες με ή χωρίς στόμιο.',
      en: 'Flexible pouch packaging solutions with or without spout.'
    },
    category: { el: 'Συσκευασία', en: 'Packaging' },
    categoryIcons: ['dairy', 'beverage', 'bakery', 'meat', 'oils', 'spreads', 'fruit', 'ready-meals'],
    website: 'https://polpak.com.pl'
  },
  {
    name: 'STM Pack',
    logo: stmPackLogo,
    founded: '1974',
    hq: { el: 'Πολωνία', en: 'Poland' },
    description: {
      el: 'Ολοκληρωμένες γραμμές εμφιάλωσης και κονσερβοποίησης για τον κλάδο των ποτών.',
      en: 'Turnkey bottling and canning lines for the beverage segment.'
    },
    strengths: {
      el: 'Πλήρεις γραμμές για νερό, μπύρα, αναψυκτικά, γάλα, έλαια — από εμφύσηση έως παλετοποίηση.',
      en: 'Complete lines for water, beer, soft drinks, milk and oils — from blow molding to palletizing.'
    },
    category: { el: 'Ποτά', en: 'Beverages' },
    categoryIcons: ['beverage'],
    website: 'https://stm-pack.com'
  },
  {
    name: 'Vezzadini',
    logo: vezzadiniLogo,
    founded: '1954',
    hq: { el: 'Ιταλία', en: 'Italy' },
    description: {
      el: 'Εξειδικευμένος εξοπλισμός για την επεξεργασία και συσκευασία βουτύρου.',
      en: 'Specialized equipment for butter processing and packaging.'
    },
    strengths: {
      el: 'Μακρόχρονη εμπειρία σε λύσεις για τον κλάδο του βουτύρου.',
      en: 'Long-standing expertise in butter industry solutions.'
    },
    category: { el: 'Βούτυρο', en: 'Butter' },
    categoryIcons: ['dairy', 'spreads'],
    website: 'https://vezzadini.com'
  }
];

/** Maps industry page slugs to the industry ids used in `categoryIcons`. */
export const industrySlugToPartnerId: Record<string, string> = {
  dairy: 'dairy',
  beverage: 'beverage',
  'bakery-grains-snacks': 'bakery',
  'meat-fish-eggs': 'meat',
  'oils-fats': 'oils',
  'spreads-sauces': 'spreads',
  'fruit-vegetables': 'fruit',
  'ready-meals': 'ready-meals',
};

export const getPartnersForIndustry = (slug: string): Partner[] => {
  const id = industrySlugToPartnerId[slug];
  return id ? partnersData.filter((p) => p.categoryIcons.includes(id)) : [];
};
